import Vue from 'vue';
import Router from 'vue-router';
import Layout from './components/layout.vue';

//路由报错Navigation aborted from "/a" to "/b" via a navigation guard.
//所以添加以下代码段，未找到具体原因
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    else
        return originalPush.call(
            this,
            location,
            () => {},
            () => {}
        );

    // return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // 登录
        {
            path: '/login',
            name: '登录',
            component: () => import('./views/login/index.vue')
        },
        // 忘记密码
        {
            path: '/forgetPwd',
            name: '忘记密码',
            component: () => import('./views/login/forgetPwd.vue')
        },
        // 注册
        {
            path: '/registered/step1',
            name: '注册',
            component: () => import('./views/registered/step1.vue')
        },
        {
            path: '/registered/step2',
            name: 'step2',
            component: () => import('./views/registered/step2.vue')
        },
        {
            path: '/registered/step3',
            name: 'step3',
            component: () => import('./views/registered/step3.vue')
        },
        {
            path: '/allOrder',
            name: '订单出库看板',
            component: () => import('./views/screen/allOrder.vue')
        },
        {
            path: '/zoneOrder',
            name: '出库单投屏',
            component: () => import('./views/screen/zoneOrder.vue')
        },
        {
            path: '/screen',
            name: '出货投屏',
            component: () => import('./views/screen/shipment.vue')
        },
        // 工作后台
        {
            path: '/',
            // name: 'layout',
            component: () => import('./views/business/index.vue'),
            children: [
                {
                    path: '/',
                    name: '首页',
                    meta: {
                        keepAlive: true
                    },
                    component: () => import('./views/business/workbench/desktop.vue')
                },
                //消息列表
                {
                    path: '/message',
                    name: 'message',
                    meta: {
                        keepAlive: true
                    },
                    component: () => import('./views/business/workbench/message.vue')
                },
                // 使用教程
                {
                    path: '/tutorial/index',
                    name: '使用教程',
                    component: () => import('./views/tutorial/index.vue')
                },
                {
                    path: '/tutorial/videoIndex',
                    name: '使用教程',
                    component: () => import('./views/tutorial/videoIndex.vue')
                },
                {
                    path: '/tutorial/detail',
                    name: '教程明细',
                    component: () => import('./views/tutorial/detail.vue')
                },
                //信息设置
                {
                    path: '/msgSetting',
                    name: '我的企业',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/msgSetting/msgSetting.vue'),
                    children: [
                        {
                            path: '/msgSetting',
                            name: '基本信息',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/msgSetting/companyMsg',
                                    name: '企业详情',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/companyMsg.vue')
                                },
                                {
                                    path: '/msgSetting/addressManage',
                                    name: '地址管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/addressManage.vue')
                                },
                                {
                                    path: '/msgSetting/certificationManage',
                                    name: '认证管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/certificationManage.vue')
                                }
                            ]
                        },
                        {
                            path: '/businessHoursSetting',
                            name: '营业信息',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/entpInfoManage/businessHoursSetting',
                                    name: '营业时间',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/client.vue')
                                },
                                {
                                    path: '/entpInfoManage/mainBusiness',
                                    name: '主营业务',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/service.vue')
                                }
                            ]
                        },
                        {
                            path: '/studyGardensManage',
                            name: '学习园地',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/studyGardens/studyGardensManagement',
                                    name: '学习园地',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/studyGardens.vue')
                                }
                            ]
                        },
                        {
                            path: '/staffManage',
                            name: '人事管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/msgSetting/orgs',
                                    name: '组织架构',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/orgManage.vue')
                                },
                                {
                                    path: '/msgSetting/roles',
                                    name: '角色管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/rolesManage.vue')
                                },
                                {
                                    path: '/staffManagement',
                                    name: '员工管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/msgSetting/staffManagement',
                                            name: '员工数据',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/msgSetting/staffManagement.vue')
                                        },
                                        {
                                            path: '/msgSetting/rAndPRecords',
                                            name: '赏罚记录',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/msgSetting/rewardAndPubishRecord.vue')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: '/sysSetting',
                            name: '系统设置',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/entpInfoManage/sysConfigs',
                                    name: '功能设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/sysConfigs.vue')
                                },
                                {
                                    path: '/softwarePackage',
                                    name: '软件套餐',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/softwarePackage.vue')
                                },
                                {
                                    path: '/attrConfigs',
                                    name: '属性设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/attrConfigs.vue')
                                },
                                {
                                    path: '/entpInfoManage/operatedLogs',
                                    name: '操作日志',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/operatedLogs.vue')
                                },
                                {
                                    path: '/entpInfoManage/loginLogDatas',
                                    name: '登录日志',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/loginLogs.vue')
                                },
                                {
                                    path: '/msgSetting/printerManage',
                                    name: '打印机',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/printerManage.vue')
                                },
                                {
                                    path: '/msgSetting/orderPushSets',
                                    name: '电商订单推送设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/msgSetting/orderPushSets.vue')
                                },
                                {
                                    path: '/inventoryManage/goodsRecover',
                                    name: '商品恢复',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/goodsDelList.vue')
                                },
                                {
                                    path: '/sysSetting',
                                    name: '支付信息',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/softwarePackage/softwarePay',
                                            name: '软件支付',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/msgSetting/softwarePay.vue')
                                        },
                                        {
                                            path: '/softwarePackage/softwarePayWeChat',
                                            name: '微信支付',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/msgSetting/softwarePayWeChat.vue')
                                        },
                                        {
                                            path: '/softwarePackage/softwarePayAliPay',
                                            name: '支付宝支付',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/msgSetting/softwarePayAliPay.vue')
                                        },
                                        {
                                            path: '/softwarePackage/payWechatResult',
                                            name: '结果支付',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/msgSetting/payWechatResult.vue')
                                        },
                                        // 支付宝支付结果
                                        {
                                            path: '/payAliResult',
                                            name: 'payAliResult',
                                            component: () => import('./views/business/shop/payAliResult.vue')
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                //采购管理
                {
                    path: '/purchaseManage',
                    name: '采购管理',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/purchaseManage/purchaseManage.vue'),
                    children: [
                        {
                            path: '/purchaseManage',
                            name: '供应商管理',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/purchaseManage/supplierManage',
                                    name: '供应商数据列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/supplier.vue')
                                },
                                {
                                    path: '/purchaseManage/supplierManage/importExcel',
                                    name: '导入供应商信息',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/customerManage/importExcel.vue')
                                }
                            ]
                        },
                        {
                            path: '/stockPurchase',
                            name: '快速采购',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/inventoryBuy',
                                    name: '紧缺库存采购',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/purchaseManage/stockPurchase',
                                            name: '库存商品列表',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/inventoryBuy.vue')
                                        },
                                        {
                                            path: '/purchaseManage/urgentPurchase',
                                            name: '紧急采购（新）',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/urgentPurchase.vue')
                                        },
                                        {
                                            path: '/purchaseManage/stockPurchase/easyPurchase',
                                            name: '库存转单操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/quickBuy.vue')
                                        },
                                        {
                                            path: '/purchaseManage/stockPurchase/easyPurchase_new',
                                            name: '库存转单操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/quickBuy_new.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/easyPurchase',
                                    name: '销售单转采购',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/purchaseManage/transToPurchaseOrder',
                                            name: '可转销售单',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/transToPurchaseOrder.vue')
                                        },
                                        {
                                            path: '/purchaseManage/purchaseOrders/easyPurchase',
                                            name: '转化操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/quickBuy.vue')
                                        },
                                        {
                                            path: '/purchaseManage/purchaseOrders/easyPurchase_new',
                                            name: '转化操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/quickBuy_new.vue')
                                        },
                                        {
                                            path: '/purchaseManage/costVerification',
                                            name: '核实成本价',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/costVerification.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/multiSupplierPurchase',
                                    name: '多供应商采购',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/purchaseManage/multiSupplierPurchase',
                                            name: '库存商品列表',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/multiSupplierPurchase.vue')
                                        },
                                        {
                                            path: '/purchaseManage/multiSupplierPurchaseEdit',
                                            name: '新增采购单',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/multiSupplierPurchaseEdit.vue')
                                        },
                                        {
                                            path: '/purchaseManage/multiSupplierPurchaseEdit_h',
                                            name: '新增采购单',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/multiSupplierPurchaseEdit_h.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/autoPurchase',
                                    name: '自动采购管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/purchaseManage/autoPurchase',
                                            name: '推荐采购列表',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/autoPurchase.vue')
                                        },
                                        {
                                            path: '/purchaseManage/autoPurchaseEdit',
                                            name: '新增采购单',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/autoPurchaseEdit.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/urgentGoodsPur',
                                    name: '急件采购',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/purchaseManage/urgentGoodsPur',
                                            name: '销售单急件商品列表',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/urgentGoodsPur.vue')
                                        }
                                        ,
                                        {
                                            path: '/purchaseManage/urgentGoodsToPur',
                                            name: '新增采购单',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/urgentGoodsToPur.vue')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: '/inquirySheet',
                            name: '采购询价管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/purchaseManage/inquirySheet',
                                    name: '询价单列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierRFQ.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/edit',
                                    name: '询价单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierRFQEdit.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/edit_v2',
                                    name: '询价单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierRFQEdit_v2.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/edit_v3',
                                    name: '询价单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierRFQEdit_v3.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/histories',
                                    name: '配件询价历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierRFQHistories.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/transToPurchaseOrders',
                                    name: '询价转单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderEdit_v2.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/transToPurchaseOrders_V3',
                                    name: '询价转单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderEdit_v3.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/importToCreateOrder',
                                    name: '导入开单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/importToCreateIOrder.vue')
                                },
                                {
                                    path: '/purchaseManage/inquirySheet/orderGoodsMannger',
                                    name: '在订管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierOrderGoodsMannger.vue')
                                }
                            ]
                        },
                        {
                            path: '/purchaseOrdersManage',
                            name: '采购订单管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/purchaseManage/purchaseOrders',
                                    name: '采购订单列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrder.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/edit',
                                    name: '采购订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderEdit_v1.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/edit_v2',
                                    name: '采购订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderEdit_v2.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/edit_v3',
                                    name: '采购订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderEdit_v3.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/histories',
                                    name: '配件采购历史',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierOrderHistories.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/planDetail',
                                    name: '采购计划明细',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierOrderPlanHistories.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/transToInquirySheet',
                                    name: '采购转单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierRFQEdit_v2.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/shareCost',
                                    name: '成本分摊',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/shareCost.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/check',
                                    name: '查看采购订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/checkPurchaseOrder.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/importOrdersExcel',
                                    name: '导入采购订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/importOrdersExcel.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/importToCreateOrder',
                                    name: '导入开单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/importToCreateOrder.vue')
                                },
                                {
                                    path: '/purchaseManage/purchaseOrders/importCYOrders',
                                    name: '导入采购订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/importCYOrders.vue')
                                }
                            ]
                        },
                        {
                            path: '/purchasesReturnsManage',
                            name: '采购退货管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/purchaseManage/purchasesReturns',
                                    name: '采购退货列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesReturns.vue')
                                },
                                {
                                    path: '/purchaseManage/purchasesReturns/edit',
                                    name: '采购退货操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesReturnsEdit_v1.vue')
                                },
                                {
                                    path: '/purchaseManage/purchasesReturns/edit_v2',
                                    name: '采购退货操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesReturnsEdit_v2.vue')
                                },
                                {
                                    path: '/purchaseManage/purchasesReturns/edit_v3',
                                    name: '采购退货操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesReturnsEdit_v3.vue')
                                },
                                {
                                    path: '/purchaseManage/purchasesReturns/retrunPrhistories',
                                    name: '采购退货历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/supplierReturnHistories.vue')
                                }
                            ]
                        },
                        {
                            path: '/shareInventory/siPurchaseOrders',
                            name: '现货订单',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/siPurchaseOrders.vue')
                        },
                        {
                            path: '/business/purchaseManage/rfq',
                            name: '询价订单(车回佳)',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/purchaseManage/rfq.vue')
                        },
                        {
                            path: '/business/purchaseManage/rfqEdit',
                            name: '询价订单(车回佳)编辑',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/purchaseManage/rfqEdit.vue')
                        },
                        {
                            path: '/business/purchaseManage/buyorder',
                            name: '采购订单(车回佳)',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/purchaseManage/buyorder.vue')
                        },
                        {
                            path: '/business/purchaseManage/orderDetails',
                            name: '采购订单(车回佳)编辑',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/purchaseManage/orderDetails.vue')
                        },
                        {
                            path: '/business/purchaseManage/transToOrder',
                            name: '转为采购订单(车回佳)',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/purchaseManage/transToOrder.vue')
                        }
                    ]
                },
                //汽修系统
                {
                    path: '/automotiveRepairSys',
                    name: '汽修系统',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/repairMamage/clientMamage.vue'),
                    children: [
                        {
                            path: '/automotiveRepairSys/carOwnerMamage',
                            name: '车主管理',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/repairMamage/carOwnerData.vue')
                        },
                        {
                            path: '/automotiveRepairSys/repairManage',
                            name: '维修管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/repairMamage/reservation',
                                    name: '预约管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/repairMamage/reservation.vue')
                                },
                                {
                                    path: '/repairMamage/createResult',
                                    name: '检修结果',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/repairMamage/createResult.vue')
                                },
                                // {
                                //     path: '/business/clientMamage/overhaul', 先隐藏，qdl 2019/10/26
                                //     name: '检修管理',
                                //     component: () => import('./views/business/clientMamage/overhaul.vue'),
                                // },
                                {
                                    path: '/repairMamage/order',
                                    name: '订单管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/repairMamage/order.vue')
                                },
                                {
                                    path: '/repairMamage/orderDetails',
                                    name: '订单详细',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/repairMamage/orderDetails.vue')
                                },
                                {
                                    path: '/repairMamage/editOrder',
                                    name: '新增维修订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/repairMamage/editOrder.vue')
                                }
                            ]
                        },
                        {
                            path: '/attendanceSystem/revenueManage',
                            name: '营收管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/revenueManage/analyze',
                                    name: '财务分析',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/finance.vue')
                                },
                                {
                                    path: '/revenueManage/repairOrder',
                                    name: '维修营收',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/repairOrder.vue')
                                },
                                {
                                    path: '/revenueManage/recommend',
                                    name: '推荐营收',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/recommend.vue')
                                },
                                {
                                    path: '/revenueManage/withdraw',
                                    name: '提现管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/withdraw.vue')
                                }
                            ]
                        }
                    ]
                },
                // 库存管理
                {
                    path: '/inventoryManage',
                    name: '库存管理',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/goods/goods.vue'),
                    children: [
                        {
                            path: '/inventoryManage/takeOutManage',
                            name: '出仓管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/inventoryManage/salesOrderTakeOutManage',
                                    name: '销售订单出仓',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/salesOrder/takeOut',
                                            name: '销售出仓',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/salesManage/salesOrderTakeOut.vue')
                                        },
                                        // {
                                        //     path: '/inventoryManage/salesOrder/scanOut',
                                        //     name: '销售扫码出仓',
                                        //     meta: {
                                        //         keepAlive: true
                                        //     },
                                        //     component: () => import('./views/business/salesManage/salesOrderScanTakeOut.vue')
                                        // },
                                        {
                                            path: '/inventoryManage/salesOrder/scanOut',
                                            name: '扫销售单出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/salesManage/salesOrderScanOut.vue')
                                        },
                                        {
                                            path: '/inventoryManage/salesOrder/scanOut_v2',
                                            name: '销售扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/salesManage/salesOrderScanOut_v2.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/inventoryManage/SalesOutWhOrdersTakeOutManage',
                                    name: '销售出库单出仓',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/salesOrder/saleOutTakeOut',
                                            name: '销售出库单出仓',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/salesManage/salesOutWhOrders.vue')
                                        },
                                        {
                                            path: '/inventoryManage/salesOrder/saleOutTakeOut/outGoods',
                                            name: '销售出库单出仓操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/salesManage/salesOutWhOrderDetails.vue')
                                        },
                                        // {
                                        //     path: '/inventoryManage/salesOrder/saleOutTakeOut/scanOut',
                                        //     name: '销售扫码出仓',
                                        //     meta: {
                                        //         keepAlive: true
                                        //     },
                                        //     component: () => impor./views/business/salesManage/salesOutOrderScanTakeOut_Del.vuevue')
                                        // },
                                        {
                                            path: '/inventoryManage/salesOrder/saleOutTakeOut/scanOutBoxV',
                                            name: '销售出库单扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/salesManage/salesOutWhOrderScanOut_v2.vue')
                                        },
                                        {
                                            path: '/inventoryManage/salesOrder/saleOutTakeOut/scanOut',
                                            name: '销售出库单扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/salesManage/salesOutWhOrderScanOut.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/inventoryManage/PurReutnTakeOutManage',
                                    name: '采购退货出仓',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/purchasesReturns/takeOut',
                                            name: '采购退货出仓',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/purchaseManage/purchasesReturnsTakeOut.vue')
                                        },
                                        {
                                            path: '/inventoryManage/purReturn/scanOut',
                                            name: '采购退货扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/purReturnScanTakeOut.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/inventoryManage/salesOrder/takeOut/edit',
                                    name: '销售出仓操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderEdit_v2.vue')
                                },
                                {
                                    path: '/inventoryManage/purchasesReturns/takeOut/edit',
                                    name: '采购退货出仓操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesReturnsEdit_v1.vue')
                                },
                                {
                                    path: '/inventoryManage/saleOrderAssign',
                                    name: '销售派单管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/saleOrderAssign.vue')
                                }
                            ]
                        },
                        {
                            path: '/inventoryManage/packingList',
                            name: '装箱单管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/inventoryManage/packingList',
                                    name: '装箱单列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/goods/packingList.vue')
                                },
                                {
                                    path: '/inventoryManage/packingList/edit',
                                    name: '装箱单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/packingListEdit.vue')
                                }
                            ]
                        },
                        {
                            path: '/inventoryManage/takeInManage',
                            name: '入仓管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/inventoryManage/purchasesOrder/takeIn',
                                    name: '采购订单入仓',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderTakeIn.vue')
                                },
                                {
                                    path: '/inventoryManage/salesReturns/takeIn',
                                    name: '销售退货入仓',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnsTakeIn.vue')
                                },
                                {
                                    path: '/inventoryManage/purchasesOrder/takeIn/edit',
                                    name: '采购入仓操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/purchaseManage/purchasesOrderEdit_v2.vue')
                                },
                                {
                                    path: '/inventoryManage/salesReturns/takeIn/edit',
                                    name: '销售退货入仓操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnsEdit_v1.vue')
                                },
                                {
                                    path: '/inventoryManage/salesReturns/scanIn',
                                    name: '销售退货扫码入仓',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnScanTakeIn.vue')
                                }
                            ]
                        },
                        {
                            path: '/inventoryManage/warehouseManage',
                            name: '仓库管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/inventoryManage/warehouseManage',
                                    name: '仓位管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/warehouse.vue')
                                },
                                {
                                    path: '/inventoryManage/limitSets',
                                    name: '各库商品上下限设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children:[
                                        {
                                            path: '/inventoryManage/limitSets',
                                            name: '各库商品上下限设置',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/limitSets.vue'),
                                        },
                                        {
                                            path: '/inventoryManage/limitWarningSet',
                                            name: '触顶/底预警',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/limitWarningSet.vue') 
                                        }
                                    ]
                                },
                                {
                                    path: '/inventoryManage/monitorDevices',
                                    name: 'cctv',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/monitorDevices.vue')
                                },
                                {
                                    path: '/inventoryManage/singleTransWarehouse',
                                    name: '单品调仓',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/transWarehouseSingleGoods.vue')
                                },
                                {
                                    path: '/inventoryManage/printInOutOrder',
                                    name: '打印出/入库单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/printInOutRecords.vue')
                                },
                                {
                                    path: '/inventoryManage/warePosition',
                                    name: '管理仓位',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/warePosition.vue')
                                },
                                {
                                    path: '/inventoryManage/toBeShippedZoneManage',
                                    name: '管理待发区',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/ToBeShippedZoneManage.vue')
                                },
                                {
                                    path: '/inventoryManage/zoneManage',
                                    name: '管理区域',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/zoneManage.vue')
                                },
                                {
                                    path: '/inventoryManage/batchAddSpaces',
                                    name: '批量添加仓位',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/warePositionBatchAdd.vue')
                                },
                                {
                                    path: '/warehouseManage',
                                    name: '移库调仓',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/transWarehouse',
                                            name: '调仓清单',
                                            query: {
                                                from: 'inventory'
                                            },
                                            meta: {
                                                keepAlive: true,
                                                from: 'inventory'
                                            },
                                            component: () => import('./views/business/goods/newTransWarehouse.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/edit',
                                            name: '调仓操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/newTransWarehouseEdit.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/edit_v2',
                                            name: '调仓操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/newTransWarehouseEdit_v2.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/transOrderScanOut',
                                            name: '扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/newTransScanOut.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/transOrderScanOut_v2',
                                            name: '扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/newTransScanOut_v2.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/transOrderScanIn',
                                            name: '扫码入仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/newTransScanIn.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/transOrderScanIn_v2',
                                            name: '扫码入仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/newTransScanIn_v2.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/importTransWarehouseExcel',
                                            name: '导入开单',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/importToCreateTransWarehouse.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/Historiesor',
                                            name: '调拨配件历史',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/transWarehouseHistories.vue')
                                        },
                                        {
                                            path: '/inventoryManage/transWarehouse/PlanDetail',
                                            name: '调拨配件计划',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/goods/transWarehouseHistories.vue')
                                        },
                                        {
                                            path: '/warehouseManage',
                                            name: '同库改仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: Layout,
                                            children: [
                                                {
                                                    path: '/inventoryManage/transSpaces',
                                                    name: '改仓单',
                                                    meta: {
                                                        keepAlive: false
                                                    },
                                                    component: () => import('./views/business/goods/transWarehouse.vue')
                                                },
                                                {
                                                    path: '/inventoryManage/transSpaces/edit',
                                                    name: '改仓操作',
                                                    meta: {
                                                        keepAlive: false
                                                    },
                                                    component: () => import('./views/business/goods/transWarehouseEdit.vue')
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: '/processTransManage',
                                    name: '加工调拨管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/processTrans',
                                            name: '加工调拨',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/processTransManage/processTrans.vue')
                                        },
                                        {
                                            path: '/inventoryManage/processTrans/edit',
                                            name: '加工单操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/processTransManage/processTransEdit.vue')
                                        },
                                        {
                                            path: '/inventoryManage/processTrans/transScanOut',
                                            name: '加工扫码出仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/processTransManage/processTransScanOut.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/inventoryManage/InOutRecords',
                                    name: '出入仓记录',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/inOutRecords.vue')
                                },
                                {
                                    path: '/checkInventoryManage',
                                    name: '库存盘点',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/checkInventory',
                                            name: '盘点清单',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/goods/inventory.vue')
                                        },
                                        {
                                            path: '/inventoryManage/checkInventory/edit',
                                            name: '盘点操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/inventoryEdit.vue')
                                        },
                                        {
                                            path: '/inventoryManage/checkInventory/checkRecords',
                                            name: '核查记录',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/inventoryCheckRecords.vue')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: '/inventoryManage',
                            name: '库存商品管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/goodsManage',
                                    name: '商品管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/goods',
                                            name: '商品清单',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/goods/goodsList.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goodsManage/transToStockPurchase',
                                            name: '转单操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/purchaseManage/quickBuy_new.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/importExcel',
                                            name: '导入商品信息',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/importExcel.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/addgoods',
                                            name: '新增配件信息',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/addgoods.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/exportExcel',
                                            name: '导出商品信息',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/exportExcel.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/goodsMergeOrders',
                                            name: '合并清单',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/goods/goodsMergeOrders.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/goodsMergeEdit',
                                            name: '编辑合并清单',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/goodsMergeEdit.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/goodsViceSetsList',
                                            name: '设置主附商品',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/goodsViceSetsList.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/setViceGoods',
                                            name: '设置主附商品',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/setViceGoods.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/labelsManage',
                                    name: '标签管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/goods/Labels',
                                            name: '标签列表',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/labelList.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/archLabels',
                                            name: '归档的标签',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/labelArchList.vue')
                                        },
                                    ]
                                },
                                {
                                    path: '/setsManage',
                                    name: '套包管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/goods/sets',
                                            name: '套包列表',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/goods/setList.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/sets/setEdit',
                                            name: '套包配置',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/setEdit.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/setsManage',
                                    name: '套包组装单',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: Layout,
                                    children: [
                                        {
                                            path: '/inventoryManage/goods/setOrders',
                                            name: '组装单列表',
                                            meta: {
                                                keepAlive: true
                                            },
                                            component: () => import('./views/business/goods/setOrderList.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/sets/setOrderEdit',
                                            name: '组装单操作',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/setOrderEdit.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/sets/setOrderScanOut',
                                            name: '扫码备货',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/setOrderScanOut.vue')
                                        },
                                        {
                                            path: '/inventoryManage/goods/sets/setOrderScanPack',
                                            name: '扫码组包',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/setOrderScanPack.vue')
                                        }
                                    ]
                                },
                                {
                                    path: '/boxesManage',
                                    name: '箱子管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: Layout,
                                    // component: () => import('./views/business/goods/boxesList.vue'),
                                    children: [
                                        {
                                            path: '/inventoryManage/boxes',
                                            name: '箱子列表',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/boxesList.vue')
                                        },
                                        {
                                            path: '/inventoryManage/boxes/scanIn',
                                            name: '扫箱子入仓',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/boxesScanIn.vue')
                                        },
                                        {
                                            path: '/inventoryManage/boxes/goodsSanIn',
                                            name: '扫商品入箱子',
                                            meta: {
                                                keepAlive: false
                                            },
                                            component: () => import('./views/business/goods/boxGoodsSanIn.vue')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: '/logistics',
                            name: '物流管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/logistics/searchLine',
                                    name: '找物流',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/logistics/searchSpecialLine.vue'),
                                    children: []
                                },
                                {
                                    path: '/logistics/entpLine',
                                    name: '我的物流',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/logistics/entpSpecialLine.vue'),
                                    children: []
                                },
                                {
                                    path: '/logistics/importExcel',
                                    name: '导入物流信息',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/logistics/importExcel.vue'),
                                    children: []
                                },
                                {
                                    path: '/logistics/packVideo',
                                    name: '打包视频教程',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/logistics/packVideo.vue'),
                                    children: []
                                },
                                {
                                    path: '/logistics/packVideo/addPackVideo',
                                    name: '打包教程',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/logistics/addPackVideo.vue')
                                }
                            ]
                        }
                    ]
                },
                //财务管理（外贸专用吧，其实就旧需求，做得不完善）
                {
                    path: '/financeManage',
                    name: '财务管理',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/revenue/revenue.vue'),
                    children: [
                        {
                            path: '/financeManage/receivable',
                            name: '财务应收',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/salesOrder/gathering',
                                    name: '销售订单收款',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/salesOrderGathering.vue')
                                },
                                {
                                    path: '/financeManage/purchasesReturns/gathering',
                                    name: '采购退货收款',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/purchasesReturnsGathering.vue')
                                },
                                {
                                    path: '/financeManage/salesOrder/gathering/confirmReceipt',
                                    name: '销售订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/confirmReceipt.vue')
                                },
                                {
                                    path: '/financeManage/purchasesReturns/gathering/confirmPurchasesRefunds',
                                    name: '采购退货收款操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/confirmPurchasesRefunds.vue')
                                }
                            ]
                        },
                        {
                            path: '/financeManage/payable',
                            name: '财务应付',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/purchasesOrder/payment',
                                    name: '采购订单付款',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/purchasesOrderPayment.vue')
                                },
                                {
                                    path: '/financeManage/salesReturns/payment',
                                    name: '销售退货付款',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/salesReturnsPayment.vue')
                                },
                                {
                                    path: '/financeManage/purchasesOrder/payment/confirmPayment',
                                    name: '采购订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/confirmPayment.vue')
                                },
                                {
                                    path: '/financeManage/salesReturns/payment/confirmSalesRefunds',
                                    name: '销售售后退款操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue/confirmSalesRefunds.vue')
                                }
                            ]
                        },
                        {
                            path: '/financeStatistics',
                            name: '财务统计',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/overview',
                                    name: '数据概览',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/financialStatistics.vue')
                                },
                                // {
                                //     path: '/financeManage/statistics',
                                //     name: '数据统计',
                                //     meta: {
                                //         keepAlive: true
                                //     },
                                //     component: () => import('./views/business/revenue/financialAllStat.vue'),
                                // },
                                {
                                    path: '/financeManage/analyzes',
                                    name: '数据分析',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/financialStatistics.vue')
                                }
                            ]
                        },
                        {
                            path: '/financeManage/interact',
                            name: '财务往来',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/records',
                                    name: '财务流水',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/flow.vue')
                                },
                                {
                                    path: '/financeManage/cusInteract',
                                    name: '客户往来',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/cusInteract.vue')
                                },
                                {
                                    path: '/financeManage/supInteract',
                                    name: '供应商往来',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/supInteract.vue')
                                },
                                {
                                    path: '/financeManage/settlement',
                                    name: '财务结算',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue/settlement.vue')
                                }
                            ]
                        }
                    ]
                },
                //财务管理（崇峰专用吧，按照长远流程，重新做的简陋版）
                {
                    path: '/financeManage_n',
                    name: '财务管理',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/revenue_n/revenue_n.vue'),
                    children: [
                        {
                            path: '/financeManage/billConfirms',
                            name: '单据确认',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/billConfirms/deliveryConfirms',
                                    name: '出库确认',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/deliveryConfirms.vue')
                                },
                                {
                                    path: '/financeManage/billConfirms/stockInConfirms',
                                    name: '入库确认',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/stockInConfirms.vue')
                                }
                            ]
                        },
                        {
                            path: '/financeManage/applies',
                            name: '财务申请',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/applies/receipts',
                                    name: '收款申请',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/receiptsApplies.vue')
                                },
                                {
                                    path: '/financeManage/applies/payments',
                                    name: '付款申请',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/paymentApplies.vue')
                                }
                            ]
                        },
                        {
                            path: '/financeSettlements',
                            name: '财务结算',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/settlements/customers',
                                    name: '收款确认',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/receiptsConfirms.vue')
                                },
                                {
                                    path: '/financeManage/settlements/suppliers',
                                    name: '付款确认',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/paymentConfirms.vue')
                                }
                            ]
                        },
                        {
                            path: '/recAndPayManagement',
                            name: '应收应付管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/randp/summaries',
                                    name: '应收应付汇总',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/itemizedSumarry.vue')
                                },
                                {
                                    path: '/financeManage/randp/itemizedAccounts',
                                    name: '明细帐',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_n/itemizedAccounts.vue')
                                }
                            ]
                        }
                    ]
                },
                //财务管理（海口专用吧，按照长远流程，重新做的简陋版）
                {
                    path: '/financeManage_h',
                    name: '财务管理',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/revenue_h/revenue_h.vue'),
                    children: [
                        {
                            path: '/financeManage/billConfirms_h',
                            name: '单据确认',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/billConfirms/deliveryConfirms_h',
                                    name: '出库确认',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/deliveryConfirms.vue')
                                },
                                {
                                    path: '/financeManage/billConfirms/stockInConfirms_h',
                                    name: '入库确认',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/stockInConfirms.vue')
                                }
                            ]
                        },
                        {
                            path: '/recAndPayManagement_h',
                            name: '账款管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/randp/cusReceivable_h',
                                    name: '应收帐管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/cusReceivable.vue')
                                },
                                {
                                    path: '/financeManage/randp/supPayable_h',
                                    name: '应付帐管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/supPayable.vue')
                                },
                                {
                                    path: '/financeManage/randp/logisticsRec_h',
                                    name: '物流托收管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/logisticsRec.vue')
                                }
                            ]
                        },
                        {
                            path: '/summary_h',
                            name: '应收应付管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/financeManage/settlement/cusSettlement_h',
                                    name: '应收帐欠款',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/cusSettlement.vue')
                                },
                                {
                                    path: '/financeManage/settlement/supSettlement_h',
                                    name: '应付帐欠款',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/supSettlement.vue')
                                },
                                {
                                    path: '/financeManage/settlement/logisticsSettlement_h',
                                    name: '托收帐欠款',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/revenue_h/logisticsSettlement.vue')
                                },
                                {
                                    path: '/financeManage/settlement/dailySummary_h',
                                    name: '日营业统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_h/dailySummary.vue')
                                }
                            ]
                        },
                        {
                            path: '/financeManage/outRecords',
                            name: '出库明细查询',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/revenue_h/outRecords.vue'),
                            children: []
                        },
                        {
                            path: '/financeManage/inRecords',
                            name: '入库明细查询',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/revenue_h/inRecords.vue'),
                            children: []
                        }
                    ]
                },
                // 汽配快搜
                {
                    path: '/search',
                    name: '汽配快搜',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/search/search.vue'),
                    children: [
                        {
                            path: '/search/qpSearch',
                            name: '配件库',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/search/qpSearch.vue')
                        },
                        {
                            path: '/search/qpDetail',
                            name: '配件详情',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/search/qpDetail.vue')
                        },
                        {
                            path: '/search/vinSearch',
                            name: '搜车架号',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/search/vinSearch.vue')
                        },
                        {
                            path: '/shareInventory/siGoodsSearch',
                            name: '现货快搜',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/shareInventory/siGoodsSearch.vue')
                        },
                        {
                            path: '/shareInventory/goodsDetails',
                            name: '现货商品详情',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/siPurchaseGoodsDetails.vue')
                        }
                    ]
                },
                //数据统计
                {
                    path: '/statistics',
                    name: '数据统计',
                    meta: {
                        keepAlive: true
                    },
                    component: () => import('./views/business/statistics/statistics.vue'),
                    children: [
                        {
                            path: '/statistics/inventoryStat',
                            name: '库存成本统计',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/statistics/inventoryStat.vue')
                        },
                        {
                            path: '/statistics/costAllStat',
                            name: '成本统计',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/statistics/inventoryStat',
                                    name: '配件成本统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/inventoryStat.vue')
                                },
                                {
                                    path: '/statistics/inventoryStat_v2',
                                    name: '配件成本统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/inventoryStat_v2.vue')
                                },
                                {
                                    path: '/statistics/whStat',
                                    name: '仓库成本统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/whStat.vue')
                                },
                                {
                                    path: '/statistics/whWasteStat',
                                    name: '废品成本统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/whWasteStat.vue')
                                },
                                {
                                    path: '/statistics/labelCostStat',
                                    name: '标签成本统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/labelCostStat.vue')
                                }
                            ]
                        },
                        {
                            path: '/statistics/apAllStat',
                            name: '配件数据汇总',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/statistics/apStat',
                                    name: '配件采销统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/apStat.vue')
                                },
                                {
                                    path: '/statistics/autoPartUnsalableStat',
                                    name: '滞销品统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/AutoPartUnsalableStat.vue')
                                },
                                {
                                    path: '/statistics/labelStat',
                                    name: '新增标签统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/labelStat.vue')
                                },
                                {
                                    path: '/statistics/invenPAndLStat',
                                    name: '盘点盈亏统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/invenPAndLStat.vue')
                                },
                                {
                                    path: '/statistics/autoCateStat',
                                    name: '配件分类统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/autoCateStat.vue')
                                },
                                {
                                    path: '/statistics/apOutRecords',
                                    name: '出库明细查询',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_h/outRecords.vue')
                                },
                                {
                                    path: '/statistics/apInRecords',
                                    name: '入库明细查询',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/revenue_h/inRecords.vue')
                                },
                                {
                                    path: '/statistics/apDataAnaly',
                                    name: '配件运营分析',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/apDataAnaly.vue')
                                }
                            ]
                        },
                        {
                            path: '/statistics/operationStat',
                            name: '供应链统计',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/statistics/operationStat/custStatic',
                                    name: '客户数据统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/custStatic.vue')
                                },
                                {
                                    path: '/statistics/operationStat/supStat',
                                    name: '供应商数据统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/supStat.vue')
                                }
                            ]
                        },
                        {
                            path: '/statistics/performanceStat',
                            name: '业绩统计',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/statistics/performanceStat/salesStat',
                                    name: '销售员数据统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/salesStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/salesStat_h',
                                    name: '销售员数据统计H',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/salesStat_h.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/salesYearStat_h',
                                    name: '年度销售员数据统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/salesYearStat_h.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/purchaseStat',
                                    name: '采购员业绩统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/purchaseStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/purchaseStat_h',
                                    name: '采购员业绩统计H',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/purchaseStat_h.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/pickerStat',
                                    name: '拣货员业绩统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/pickerStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/stockUpStat',
                                    name: '上架员业绩统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/stockUpStat_v2.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/srStockUpStat',
                                    name: '销退上架业绩统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/saleReturnStockUpStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/inspectionStat',
                                    name: '验货员业绩统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/inspectionStat_v2.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/transferStat',
                                    name: '调拨拣货业绩',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/transferStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/packagingStat',
                                    name: '打包发货业绩',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/packagingStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/deliverStat',
                                    name: '配送业绩',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/deliverStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/invenCheckStat',
                                    name: '核查盘点业绩',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/invenCheckStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/salesReturnStat',
                                    name: '销售退货统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/salesReturnStat.vue')
                                },
                                {
                                    path: '/statistics/performanceStat/purchaseReturnStat',
                                    name: '采购退货统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/purchaseReturnStat.vue')
                                }
                            ]
                        },
                        {
                            path: '/statistics/payTypeStat',
                            name: '支付方式统计',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/statistics/payTypeStat/cusCotStat',
                                    name: '客户付款方式统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/cusCotStat.vue')
                                },
                                {
                                    path: '/statistics/payTypeStat/cusCotStat2',
                                    name: '客户付款方式统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/cusCotStat_V2.vue')
                                },
                                {
                                    path: '/statistics/payTypeStat/supCotStat',
                                    name: '供应商收款方式统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/statistics/supCotStat.vue')
                                }
                            ]
                        },
                        {
                            path: '/statistics/purAPStat',
                            name: '采购配件统计',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/statistics/purAPStat.vue')
                        },
                        {
                            path: '/statistics/salesAPStat',
                            name: '销售配件统计',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/statistics/salesAPStat.vue')
                        },
                        {
                            path: '/statistics/vinStat',
                            name: 'VIN解析统计',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/statistics/vinStat.vue')
                        },
                        {
                            path: '/statistics/vinRequestStat',
                            name: 'VIN请求统计功能',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/statistics/vinRequestStat.vue')
                        }
                    ]
                },
                // 合作项目
                {
                    path: '/coProjects',
                    name: '合作项目',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/coProjects/coProjects.vue'),
                    children: [
                        {
                            path: '/coProjects/goods',
                            name: '合作商品清单',
                            meta: {
                                keepAlive: true
                            },
                            component: () => import('./views/business/coProjects/projectGoodsList.vue')
                        },
                        {
                            path: '/coProjects/outRecords',
                            name: '商品出库明细',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectOutRecords.vue')
                        },
                        {
                            path: '/coProjects/inRecords',
                            name: '商品入库明细',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectInRecords.vue')
                        },
                        {
                            path: '/coProjects/goodsStats',
                            name: '商品采销统计',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectGoodsStats.vue')
                        },
                        {
                            path: '/coProjects/wasteStat',
                            name: '废品成本统计',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectWasteStat.vue')
                        },
                        {
                            path: '/coProjects/labelCostStat',
                            name: '标签成本统计',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectLabelCostStat.vue')
                        },
                        {
                            path: '/coProjects/orderOutRecords',
                            name: '订单出库明细',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectOutRecords2.vue')
                        },
                        {
                            path: '/coProjects/orderInRecords',
                            name: '订单入库明细',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/coProjects/projectInRecords2.vue')
                        }
                    ]
                },
                // 商城
                {
                    path: '/chjShop',
                    name: '改装用品商城',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/shop/shop.vue'),
                    children: [
                        {
                            path: '/shop/goodsSearch',
                            name: '车回佳商城',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/chjGoodsSearch.vue')
                        },
                        {
                            path: '/shop/buycar',
                            name: '购物车',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/buycar.vue')
                        },
                        {
                            path: '/shop/shopOrder',
                            name: '商城订单',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/shopOrder.vue')
                        },

                        {
                            path: '/shop/goodsDetail',
                            name: '商品详情',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/search/goodsDetail.vue')
                        },
                        // 购买结算
                        {
                            path: '/shop/getOrderInfo',
                            name: 'getOrderInfo',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/getOrderInfo.vue')
                        },
                        // 购买结算
                        {
                            path: '/shop/getOrderInfoFromCar',
                            name: 'getOrderInfoFromCar',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/getOrderInfoFromCar.vue')
                        },
                        // 购买结算
                        {
                            path: '/shop/orderDetails',
                            name: 'shopOrderDetails',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/orderDetails.vue')
                        },
                        // 评论
                        {
                            path: '/shop/comment',
                            name: 'comment',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/comment.vue')
                        },
                        // 支付
                        {
                            path: '/shop/pay',
                            name: 'pay',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/pay.vue')
                        },
                        // 网销库存-支付界面
                        {
                            path: '/shareInventory/pay',
                            name: 'sipay',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/pay.vue')
                        },
                        // 微信
                        {
                            path: '/shop/payWechat',
                            name: 'payWechat',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/payWechat.vue')
                        },
                        // 网销库存-微信支付
                        {
                            path: '/shareInventory/payWechat',
                            name: 'siPayWechat',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/payWechat.vue')
                        },
                        // 支付宝
                        {
                            path: '/shop/payAli',
                            name: 'payAli',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/payAli.vue')
                        },
                        // 网销库存-支付宝支付
                        {
                            path: '/shareInventory/payAli',
                            name: 'siPayAli',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/payAli.vue')
                        },
                        // 微信支付结果
                        {
                            path: '/shop/payWechatResult',
                            name: 'paySuccess',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shop/payWechatResult.vue')
                        },
                        // 网销库存-微信支付结果
                        {
                            path: '/shareInventory/payWechatResult',
                            name: 'siPaySuccess',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/payWechatResult.vue')
                        },
                        {
                            path: '/goods/invoiceDetails',
                            name: '发票详情',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/goods/invoiceDetails.vue')
                        },
                        {
                            path: '/shareInventory/siOrderConfirm',
                            name: '订单确认',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/siOrderConfirm.vue')
                        },
                        {
                            path: '/shareInventory/siPurchaseOrderDetails',
                            name: '订单详情',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/shareInventory/siPurchaseOrderDetails.vue')
                        },
                        {
                            path: '/service/after',
                            name: '售后',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/service/after.vue')
                        },
                        {
                            path: '/service/applyAfter',
                            name: '申请售后',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/service/applyAfter.vue')
                        },
                        {
                            path: '/service/afterApplyDetails',
                            name: '售后详细',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/business/service/afterApplyDetails.vue')
                        }
                    ]
                },
                // 销售管理
                {
                    path: '/salesManage',
                    name: '销售管理',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/business/salesManage/salesManage.vue'),
                    children: [
                        {
                            path: '/custManage',
                            name: '客户管理',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/salesManage/customerManage',
                                    name: '客户管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/customerManage/customerData.vue')
                                },
                                {
                                    path: '/custManage/list',
                                    name: '客户数据列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/customerManage/customerData.vue')
                                },
                                {
                                    path: '/custManage/followStat',
                                    name: '客户跟进历史',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/customerManage/followStat.vue')
                                },
                                {
                                    path: '/custManage/importExcel',
                                    name: '导入客户信息',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/customerManage/importExcel.vue')
                                },
                                {
                                    path: '/custManage/visitsTask',
                                    name: '拜访任务',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/customerManage/visitingTasksList.vue')
                                },
                                {
                                    path: '/custManage/visitsTask/edit',
                                    name: '编辑任务',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/customerManage/tasksEdit.vue')
                                },
                                {
                                    path: '/custManage/followList',
                                    name: '客户跟进',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/customerManage/customerData.vue')
                                },
                                {
                                    path: '/custManage/wechatUser',
                                    name: '微信用户',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/customerManage/wechatUser.vue')
                                }
                            ]
                        },
                        {
                            path: '/salesManage',
                            name: '销售订单管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/salesManage/salesOrder',
                                    name: '销售订单列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/salesManage/salesOrder.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/edit',
                                    name: '销售订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderEdit_v1.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/edit_v2',
                                    name: '销售订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderEdit_v2.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/edit_v3',
                                    name: '销售订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderEdit_v3.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/check',
                                    name: '查看销售订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/checkSaleOrder.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/histories',
                                    name: '配件销售历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderHistories.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/importOrdersExcel',
                                    name: '导入销售订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/importOrdersExcel.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/importToCreateOrder',
                                    name: '导入开单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/importToCreateOrder.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/importCYOrders',
                                    name: '导入销售订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/importCYOrders.vue')
                                },
                                {
                                    path: '/salesManage/salesOrder/autoPrintOrder',
                                    name: '自动打印',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/autoPrintOrder.vue')
                                }
                            ]
                        },
                        {
                            path: '/salesReturnsManage',
                            name: '销售售后管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/salesManage/salesReturns',
                                    name: '销售售后单',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/salesManage/salesReturns.vue')
                                },
                                {
                                    path: '/salesManage/salesReturns/edit',
                                    name: '销售售后操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnsEdit_v1.vue')
                                },
                                {
                                    path: '/salesManage/salesReturns/edit_v2',
                                    name: '销售售后操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnsEdit_v2.vue')
                                },
                                {
                                    path: '/salesManage/salesReturns/edit_v3',
                                    name: '销售售后操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnsEdit_v3.vue')
                                },
                                {
                                    path: '/salesManage/salesReturns/edit_v4',
                                    name: '销售售后操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnsEdit_v4.vue')
                                },
                                {
                                    path: '/salesManage/salesReturns/histories',
                                    name: '配件售后历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnHistories.vue')
                                }
                            ]
                        },
                        {
                            path: '/quotationManage',
                            name: '销售报价管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/salesManage/quotation',
                                    name: '销售报价列表',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/salesManage/bjManage.vue')
                                },
                                {
                                    path: '/salesManage/quotation/edit_v1',
                                    name: '报价单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/bjEdit_v1.vue')
                                },
                                {
                                    path: '/salesManage/quotation/edit_v2',
                                    name: '报价单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/bjEdit_v2.vue')
                                },
                                {
                                    path: '/salesManage/quotation/edit_v3',
                                    name: '报价单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/bjEdit_v3.vue')
                                },
                                {
                                    path: '/salesManage/quotation/histories',
                                    name: '配件报价历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/bjHistories.vue')
                                },
                                {
                                    path: '/salesManage/quotation/importOrdersExcel',
                                    name: '导入报价单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/importBJOrdersExcel.vue')
                                },
                                {
                                    path: '/salesManage/quotation/transToSalesOrder',
                                    name: '报价单转销售',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderEdit_v2.vue')
                                },
                                {
                                    path: '/salesManage/quotation/transToSalesOrder_v3',
                                    name: '报价单转销售',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesOrderEdit_v3.vue')
                                }
                            ]
                        },
                        {
                            path: '/shareInventoryManage',
                            name: '现货网销管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/shareInventory/myShareGoods',
                                    name: '我的网销商品',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/shareInventory/siGoodsList.vue')
                                },
                                {
                                    path: '/shareInventory/myShareOrders',
                                    name: '我的网销订单',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/shareInventory/siSalesOrders.vue')
                                },
                                {
                                    path: '/shareInventory/siSalesOrdersDetails',
                                    name: '网销订单详情',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/shareInventory/siSalesOrdersDetails.vue')
                                },
                                {
                                    path: '/shareInventory/shareGoods',
                                    name: '添加网销商品',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/shareInventory/siGoodsUnSold.vue')
                                }
                            ]
                        },
                        {
                            path: '/TransferringOrderManage',
                            name: '调拨单',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/salesManage/transferringOrder',
                                    name: '调仓清单',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/goods/newTransWarehouse.vue')
                                },
                                {
                                    path: '/salesManage/transWarehouse/edit',
                                    name: '调仓操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/newTransWarehouseEdit.vue')
                                },
                                {
                                    path: '/salesManage/transWarehouse/edit_v2',
                                    name: '调仓操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/newTransWarehouseEdit.vue')
                                },
                                {
                                    path: '/salesManage/transWarehouse/transOrderScanOut',
                                    name: '扫码出仓',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/newTransScanOut.vue')
                                },
                                {
                                    path: '/salesManage/transWarehouse/transOrderScanIn',
                                    name: '扫码入仓',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/goods/newTransScanIn.vue')
                                }
                            ]
                        }
                    ]
                },
                // 考勤系统
                {
                    path: '/attendanceSys',
                    name: '考勤系统',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/attendanceSystem/attendanceSystem.vue'),
                    children: [
                        {
                            path: '/attendanceSystem/attendanceManage',
                            name: '考勤管理',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/attendanceManage/signRecords',
                                    name: '打卡记录',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceManage/signRecords.vue')
                                },
                                {
                                    path: '/attendanceManage/attendanceReports',
                                    name: '考勤报表',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceManage/attendanceReports.vue')
                                }
                            ]
                        },
                        {
                            path: '/attendanceSystem/workTime',
                            name: '工作安排',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/workTime/myWorkTime',
                                    name: '我的排班',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/workTime/myWorkTime.vue')
                                },
                                {
                                    path: '/workTime/workTimeManage',
                                    name: '排班管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/workTime/workTimeManage.vue')
                                },
                                {
                                    path: '/workTime/addWorkTime',
                                    name: '新增排班',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/workTime/addWorkTime.vue')
                                }
                            ]
                        },
                        {
                            path: '/attendanceSystem/attendanceApply',
                            name: '考勤申请',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/attendanceApply/addApply',
                                    name: '新增申请',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceApply/addApply.vue')
                                },
                                {
                                    path: '/attendanceApply/applyManage',
                                    name: '申请管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceApply/applyManage.vue')
                                },
                                {
                                    path: '/attendanceApply/applyType',
                                    name: '申请类型',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceApply/applyType.vue')
                                },
                                {
                                    path: '/attendanceApply/approval',
                                    name: '审批流程',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceApply/approval.vue')
                                }
                            ]
                        },
                        {
                            path: '/attendanceSystem/attendanceSetting',
                            name: '考勤设置',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/attendanceSetting/vacationManage',
                                    name: '假期管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceSetting/vacationManage.vue')
                                },
                                {
                                    path: '/attendanceSetting/workTimeSections',
                                    name: '工作时段',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceSetting/workTimeSections.vue')
                                },
                                {
                                    path: '/attendanceSetting/workTimeSetManage',
                                    name: '工作班次',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceSetting/workTimeSetManage.vue')
                                },
                                {
                                    path: '/attendanceSetting/attendanceRules',
                                    name: '考勤规则',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceSetting/attendanceRules.vue')
                                },
                                {
                                    path: '/attendanceSetting/attendanceDevices',
                                    name: '设备管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceSetting/attendanceDevices.vue')
                                },
                                {
                                    path: '/attendanceSetting/workTimeSetManageEdit',
                                    name: '新增编辑班次',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/attendanceSystem/attendanceSetting/workTimeSetManageEdit.vue')
                                }
                            ]
                        }
                    ]
                },
                //企信转单操作模块
                {
                    path: '/entpTranOrder', //这个很重要，这个是联盟模块的导航栏的展示标识
                    name: '企信转单操作模块',
                    meta: {
                        keepAlive: false
                    },
                    component: () => import('./views/entpUnion/entpUnionManage.vue'),
                    children: [
                        {
                            path: '/entpFriend/orderManage/orderDetails',
                            name: '企业订单详细',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/orderManage/orderDetails.vue')
                        },
                        {
                            path: '/entpFriend/orderManage/tranSaleOrders',
                            name: '转化成销售单',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/orderManage/tranSaleOrders.vue')
                        },
                        {
                            path: '/entpFriend/orderManage/tranPurOrders',
                            name: '转化成采购单',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/orderManage/tranPurOrders.vue')
                        },
                        {
                            path: '/entpFriend/orderManage/tranSaleReturns',
                            name: '转化成销售售后单',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/orderManage/tranSaleReturns.vue')
                        },
                        {
                            path: '/entpFriend/orderManage/tranPurReturns',
                            name: '转化成采购售后单',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/orderManage/tranPurReturns.vue')
                        }
                    ]
                },
                //企业联盟新模块
                {
                    path: '/entpUnion', //这个很重要，这个是联盟模块的导航栏的展示标识
                    name: '企业联盟',
                    meta: {
                        keepAlive: false
                    },
                    component: Layout,
                    children: [
                        {
                            path: '/entpUnion/unionManage',
                            name: '联盟管理',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/unionManage/unionInfoManage.vue'),
                            children: [
                                {
                                    path: '/entpUnion/unionManage/unionInfoes',
                                    name: '联盟信息管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionInfoes.vue')
                                },
                                {
                                    path: '/entpUnion/unionManage/joinCheck',
                                    name: '审核申请加入',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionApplies.vue')
                                },
                                {
                                    path: '/entpUnion/unionManage/unionMembers',
                                    name: '联盟成员管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionMembers.vue')
                                },
                                {
                                    path: '/entpUnion/unionManage/configs',
                                    name: '联盟功能设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionConfigs.vue')
                                },
                                {
                                    path: '/entpUnion/unionManage/roleSets',
                                    name: '联盟角色设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionRoles.vue')
                                },
                                {
                                    path: '/entpUnion/unionManage/memberStaffs',
                                    name: '人员信息',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionMemberStaffs.vue')
                                },
                                {
                                    path: '/entpUnion/unionManage/unionNotices',
                                    name: '联盟公告',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionManage/unionNotices.vue')
                                }
                            ]
                        },
                        {
                            path: '/entpUnion/unionGoodsManage',
                            name: '联盟产品库',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/unionGoodsManage/unionGoodsManage.vue'),
                            children: [
                                {
                                    path: '/entpUnion/unionGoodsManage/unionGoods',
                                    name: '商品管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionGoodsManage/unionGoodsList.vue')
                                },
                                {
                                    path: '/entpUnion/unionGoodsManage/goodsList',
                                    name: '商品清单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionGoodsManage/unionGoodsListForMember.vue')
                                },
                                {
                                    path: '/entpUnion/unionGoodsManage/priceLevels',
                                    name: '价格段设置',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionGoodsManage/unionPriceLevel.vue')
                                },
                                {
                                    path: '/entpUnion/unionGoodsManage/unionGoodsImport',
                                    name: '上传联盟商品',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionGoodsManage/unionGoodsImport.vue')
                                },
                                {
                                    path: '/entpUnion/unionGoodsManage/correctionCheck',
                                    name: '纠错审核',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionGoodsManage/unionGoodsCorrect.vue')
                                },
                                {
                                    path: '/entpUnion/unionGoodsManage/unionGoodsChangePrice',
                                    name: '批量修改价格',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionGoodsManage/unionGoodsChangePrice.vue')
                                }
                            ]
                        },
                        {
                            path: '/entpUnion/unionOrdersManage',
                            name: '联盟订单管理',
                            meta: {
                                keepAlive: false
                            },
                            component: () => import('./views/entpUnion/unionOrdersManage/unionOrdersManage.vue'),
                            children: [
                                {
                                    path: '/entpUnion/unionOrdersManage/orderList',
                                    name: '联盟成员采购单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/unionOrderList.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/agentOrderList',
                                    name: '联盟成员代发单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/unionAgentOrderList.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/myUnionOrders',
                                    name: '联盟采购单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/myUnionOrders.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/myAgentOrders',
                                    name: '联盟代发单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/myAgentOrder.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/editAgentOrders',
                                    name: '编辑代发单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/editAgentSaleOrders.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/editAgentOrders_o',
                                    name: '确认（修改）代发单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/editAgentSaleOrders_o.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/tranUnionOrders',
                                    name: '联盟商品订货单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/editUnionPurOrders_v2.vue')
                                },
                                {
                                    path: '/entpUnion/unionOrdersManage/opUnionSaleOrders',
                                    name: '联盟销售订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/entpUnion/unionOrdersManage/editUnionSaleOrders_v2.vue')
                                }
                            ]
                        }
                    ]
                },
                //  电商平台
                {
                    path: '/ecPlatform',
                    name: '电商平台',
                    meta: {
                        keepAlive: true
                    },
                    component: () => import('./views/business/ecPlatform/ecPlatformManage.vue'),
                    children: [
                        {
                            path: '/ecShopsManage',
                            name: '店铺管理',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecShopsManage',
                                    name: '店铺管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/shopsManage_ec.vue'),
                                },
                                {
                                    path: '/ecPlatform/ecShopsRsGoodsList',
                                    name: '店铺商品',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/shopsRsGoodsList_ec.vue'),
                                }
                            ]
                        },
                        {
                            path: '/ecGoodsManage',
                            name: '商品管理',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecGoodsManage',
                                    name: '商品清单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/goodsList_ec.vue'),
                                },
                                {
                                    path: '/ecPlatform/ecGoodsManage/addgoods',
                                    name: '新增配件信息',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/addGoods_ec.vue')
                                },
                                {
                                    path: '/ecPlatform/ecGoodsList',
                                    name: '商品清单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/goodsList_ec_sVs.vue'),
                                },
                            ]
                        },
                        {
                            path: '/ecOrderManage',
                            name: '订单管理',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecCusManage',
                                    name: '客户管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/customerData_ec.vue'),
                                },
                                {
                                    path: '/ecPlatform/ecSalesOrder',
                                    name: '销售管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/salesOrder_ec.vue'),
                                },
                                {
                                    path: '/ecPlatform/ecSalesOrder/edit',
                                    name: '销售订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/salesOrderEdit_ec.vue')
                                },
                                 {
                                    path: '/ecPlatform/ecSalesOrder/edit_0',
                                    name: '销售订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/salesOrderEdit_ec_v0.vue')
                                },
                                 {
                                    path: '/ecPlatform/ecSalesOrder/check',
                                    name: '查看销售订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/checkSaleOrder_ec.vue')
                                },
                                {
                                    path: '/ecPlatform/ecSalesOrder/histories',
                                    name: '销售历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/salesOrderHistories_ec.vue')
                                },
                                {
                                    path: '/ecPlatform/ecReturnManage',
                                    name: '售后管理',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/salesReturns_ec.vue'),
                                },
                                {
                                    path: '/ecPlatform/ecReturnManage/histories',
                                    name: '售后历史',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/salesManage/salesReturnHistories.vue')
                                }, 
                                {
                                    path: '/ecPlatform/ecReturnManage/check',
                                    name: '查看售后订单',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/checkSalesReturnsEdit_ec.vue')
                                },
                                {
                                    path: '/ecPlatform/ecReturnManage/edit',
                                    name: '售后订单操作',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/salesReturnsEdit_ec.vue')
                                },
                                {
                                    path: '/ecPlatform/ecExpPacks',
                                    name: '快递组包',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/expPacks_ec.vue'),
                                }
                            ]
                        },
                        {
                            path: '/ecOrderSettlement',
                            name: '订单结算',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecSalesOrderGathering',
                                    name: '销售订单收款',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/salesOrderGathering_ec.vue'),
                                }
                            ]
                        },
                        {
                            path: '/ecStudyGardensManage',
                            name: '学习园地',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecStudyGardensManagement',
                                    name: '学习园地',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/studyGardens_ec.vue')
                                }
                            ]
                        },
                        {
                            path: '/ecOperAnanly',
                            name: '运营分析',
                            meta: {
                                keepAlive: true
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecGoodsSaleStat',
                                    name: '商品销量统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/goodsSaleStat_ec.vue'),
                                },
                                {
                                    path: '/ecPlatform/ecZoneSaleStat',
                                    name: '区域销量统计',
                                    meta: {
                                        keepAlive: true
                                    },
                                    component: () => import('./views/business/ecPlatform/goodsSaleStat_ec.vue')
                                }
                            ]
                        },
                        {
                            path: '/ecRevenueSettlement',
                            name: '财务结算',
                            meta: {
                                keepAlive: false
                            },
                            component: Layout,
                            children: [
                                {
                                    path: '/ecPlatform/ecCusReceivable',
                                    name: '应收帐管理',
                                    meta: {
                                        keepAlive: false
                                    },
                                    component: () => import('./views/business/ecPlatform/revenue/cusReceivable_ec.vue'),
                                },
                            ]
                        },                        
                    ]
                },
            ]
        },
        {
            path: '/noPermission',
            name: 'noPermission',
            meta: {
                keepAlive: false
            },
            component: () => import('./views/noPermission.vue')
        },
        {
            path: '*',
            name: 'errorPage',
            meta: {
                keepAlive: false
            },
            component: () => import('./views/404.vue')
        }
    ]
});
